import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewHUFeatureConfig: DeepPartial<Overview> = {
    applyPositionsForTitleCount: true,
    getSumPerTypeTotalMarketValue: true,
    sumValueFromPositions: true,
    totalMarketValueFromPositions: true,
};
